import { render, staticRenderFns } from "./accordionParent.vue?vue&type=template&id=31e97209&"
import script from "./accordionParent.vue?vue&type=script&lang=js&"
export * from "./accordionParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports